(() => {
  const initCollectionTabs = (root) => {
    const tabs = [...root.querySelectorAll('[data-tnn-tab]')];
    const panels = [...root.querySelectorAll('[data-tnn-panel]')];
    if (!tabs.length || !panels.length) return;

    const activate = (id, moveFocus = false) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.tnnTab === id;
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && moveFocus) tab.focus();
      });
      panels.forEach((panel) => {
        const active = panel.dataset.tnnPanel === id;
        panel.hidden = !active;
        panel.classList.toggle('is-active', active);
      });
    };

    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => activate(tab.dataset.tnnTab));
      tab.addEventListener('keydown', (event) => {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let next = index;
        if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        activate(tabs[next].dataset.tnnTab, true);
      });
    });
    activate((tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0]).dataset.tnnTab);
  };

  const init = (scope = document) => scope.querySelectorAll('[data-tnn-collections]').forEach(initCollectionTabs);
  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
